import { DirectionService } from '../utils/services/direction.service';
import { MediaQueryService } from '../utils/services/media-query.service';
import { ScrollLockService } from '../utils/services/scroll-lock.service';
import { ScrollService } from '../utils/services/scroll.service';
import { CONFIG_DEFAULTS } from './config-defaults';
import { versions } from './versions';

export const SharedScrollLockService = new ScrollLockService();
export const SharedScrollService = new ScrollService(); // deprecate, not used, to remove in 7.0.0
export const SharedMediaQueryService = new MediaQueryService(window);
export const SharedDirectionService = new DirectionService(document.documentElement);

export default async (): Promise<void> => {
  if (window.workbench) {
    window.workbench = { ...CONFIG_DEFAULTS, ...window.workbench };
  } else {
    window.workbench = { ...CONFIG_DEFAULTS };
  }

  window.workbench.instances.push(versions);
  SharedMediaQueryService.observe();
  validateReadingDirection();
};

function validateReadingDirection(): void {
  const dirEl = document.querySelector('[dir="ltr"], [dir="rtl"]');

  if (!dirEl) {
    console.warn('Workbench initialization: Please set [dir="ltr"] or [dir="rtl"] to fix potential styling issues');
  }
}
